export default __webpack_public_path__ + "static/media/IconAppGalleryWhite.30109012.svg";